export const USER_KEYS = {
    base: 'users',
    all: ['users'],
    list: ['users', 'list'],
    detail: (id: string) => ['users', 'detail', id]
} as const;
